import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const McoInvLineList = ({ mcoInv }) => {
  const augRowsReq = useCallback((rowsReq) => {
    if (!mcoInv) return;
    rowsReq.expr = ExprUtils.and(
      rowsReq.expr,
      ExprUtils.whereParams('rbtPeriodId', mcoInv.rbtPeriodId, 'mcoInvId', mcoInv.id),
    );
  }, []);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons); // Utlization Lines come from system only
  };

  const augFieldDefs = (fieldToFieldDef) => {
    // 1. Dimensions
    fieldToFieldDef.planCustId.precedence = 100;
    fieldToFieldDef.planCustId.hasName = true;

    fieldToFieldDef.prodId.precedence = 102;
    fieldToFieldDef.prodId.hasName = false;

    // 2. Statuses
    fieldToFieldDef.status.precedence = 1000;
    fieldToFieldDef.valStatus.precedence = 1001;

    // 3. Quantities
    fieldToFieldDef.rbtQty.precedence = 2000;
    fieldToFieldDef.incrRbtQty.precedence = 2001;
    fieldToFieldDef.incrDispQty.precedence = 2002;
    fieldToFieldDef.incrDueQty.precedence = 2003;
    fieldToFieldDef.incrPaidQty.precedence = 2004;

    // 4. Amounts
    fieldToFieldDef.extInvAmt.precedence = 3001;
    fieldToFieldDef.reimbAmt.precedence = 3002;
    fieldToFieldDef.patientLiab.precedence = 3003;
    fieldToFieldDef.incrRbtAmt.precedence = 3004;
    fieldToFieldDef.incrDispAmt.precedence = 3005;
    fieldToFieldDef.incrDueAmt.precedence = 3006;
    fieldToFieldDef.incrPaidAmt.precedence = 3007;

    // 5. Disputes
    fieldToFieldDef.dispCodeStr.precedence = 4001;
  };

  return (
    <EntityList
      entity="MCO_INV_LINE"
      augRowsReq={augRowsReq}
      augTabButtons={augTabButtons}
      augFieldDefs={augFieldDefs}
    />
  );
};
